import { registerQuery } from 'data-fetching-client';
import { fetchWorkflowsRequest } from 'email-management-lib/EmailArchiveOrDelete/api/workflows';
import allSettled from 'hs-promise-utils/allSettled';
export const FETCH_WORKFLOWS = registerQuery({
  fieldName: 'emailsWithWorkflows',
  args: ['emails'],
  async fetcher({
    emails
  }) {
    const result = [];
    const promises = emails.map(email => {
      const emailId = email.id;
      const emailUpdatedAt = email.updated;
      const emailName = email.name;
      if (email.isAutomatedLike() && email.isPublished()) {
        return fetchWorkflowsRequest(emailId).then(response => {
          result.push({
            flows: response.filter(flow => flow.enabled),
            emailUpdatedAt,
            emailName
          });
        });
      } else {
        return Promise.resolve().then(() => {
          result.push({
            flows: [],
            emailUpdatedAt,
            emailName
          });
        });
      }
    });
    await allSettled(promises);
    return result;
  }
});